import React, { useEffect, useState } from 'react';

import { FaBriefcase, FaUsers, FaIdCard, FaEnvelope, FaPhoneAlt, FaCopy } from 'react-icons/fa';

const MyProfile = () => {
  const [userData, setUserData] = useState(null);
  const [teamData, setTeamData] = useState([]);

  useEffect(() => {
    const storedUserData = localStorage.getItem('userDetails');
    if (storedUserData) {
      const parsedUserData = JSON.parse(storedUserData);
      setUserData(parsedUserData);
    }
  }, []);

  const teamNames = teamData.map(team => team.name).join(', ');

  const handleCopy = (value) => {
    navigator.clipboard.writeText(value);
    alert(`${value} copied to clipboard!`);
  };

  if (!userData) {
    return (
      <div className="bg-gray-100 min-h-screen flex items-center justify-center">
        <p className="text-gray-600">Loading your profile...</p>
      </div>
    );
  }

  return (
    <div className="bg-gray-100 min-h-screen p font-sans">
      <div className="container mx-auto px-4 mt-8">
       
       <div className="flex flex-wrap text-3xl font-bold " >
        Profile Information
       </div>

        <div className="bg-white shadow rounded-[10px] p-6 sm:p-8 mt-6 space-y-6 transition-all duration-300">
          <div className="flex items-center gap-4 border-b pb-4">
            <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-green-600 font-bold text-xl">
              {userData.name?.charAt(0) || 'U'}
            </div>
            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-800">{userData.name || 'N/A'}</h3>
              <p className="text-sm text-gray-500">{userData.role || ''}</p>
            </div>
          </div>

          <ProfileField
            label="Role"
            value={userData.role || 'N/A'}
            icon={<FaBriefcase className="text-xl text-green-600" />}
            tooltip="Your role in the organization"
          />

         

          
          <ProfileField
            label="Email ID"
            value={userData.email || 'N/A'}
            icon={<FaEnvelope className="text-xl text-red-600" />}
            onCopy={() => handleCopy(userData.email)}
            tooltip="Your email address"
          />
          <ProfileField
            label="Phone Number"
            value={userData.phoneNumber || 'N/A'}
            icon={<FaPhoneAlt className="text-xl text-yellow-600" />}
            onCopy={() => handleCopy(userData.phoneNumber)}
            tooltip="Your contact number"
          />
        </div>
      </div>
    </div>
  );
};

const ProfileField = ({ label, value, icon, onCopy, tooltip }) => (
  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4 hover:bg-gray-50 p-3 rounded-lg transition-colors duration-200">
    <label className="w-full sm:w-1/4 text-sm sm:text-base font-semibold text-gray-700 flex items-center gap-2">
      {icon} {label}
    </label>
    <div className="w-full sm:w-3/4 flex items-center gap-2">
      <div
        className="w-full bg-gray-50 border border-gray-200 rounded-md px-3 py-2 text-gray-700 text-sm sm:text-base"
        aria-label={`${label}: ${value}`}
      >
        {value}
      </div>
      {onCopy && (
        <button
          onClick={onCopy}
          className="text-gray-500 hover:text-green-600 transition-colors duration-200"
          aria-label={`Copy ${label}`}
        >
          <FaCopy className="text-sm" />
        </button>
      )}
    </div>
  </div>
);

export default MyProfile;
